import React, { useState } from 'react';
import logo from '../../assets/images/logo.png';
import Loader from '../Loader';

/**
 * Split-screen sign-in used by the admin panel and the partner portal.
 * onSubmit(email, password) → handles the API call; switchLink: { label, href }
 */
const AuthLayout = ({ eyebrow, title, subtitle, heading, intro, points = [], onSubmit, isLoading, switchLink }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        onSubmit(email, password);
    };

    return (
        <div className="hp-auth">
            <aside className="hp-auth-aside">
                <img src={logo} alt="Helpio" style={{ height: 44, alignSelf: 'flex-start' }} />
                <div>
                    <h2>{heading}</h2>
                    <p>{intro}</p>
                    <ul className="hp-auth-points">
                        {points.map(p => (
                            <li key={p.text}><i className={`bi ${p.icon}`}></i>{p.text}</li>
                        ))}
                    </ul>
                </div>
                <small style={{ color: 'rgba(255,255,255,.7)' }}>© {new Date().getFullYear()} Helpio</small>
            </aside>

            <main className="hp-auth-main">
                <div className="hp-auth-card">
                    <span className="hp-auth-logo-mobile"><img src={logo} alt="Helpio" style={{ height: 32 }} /></span>
                    {eyebrow && <div className="text-uppercase fw-bold fs-8 mb-2" style={{ color: 'var(--hp-brand-600)', letterSpacing: '.08em' }}>{eyebrow}</div>}
                    <h1>{title}</h1>
                    <p className="hp-auth-sub">{subtitle}</p>

                    <form onSubmit={submit} noValidate={false}>
                        <div className="mb-4">
                            <label htmlFor="auth-email" className="d-block">Email address</label>
                            <input id="auth-email" type="email" required autoComplete="username" value={email}
                                onChange={(e) => setEmail(e.target.value)} className="form-control" placeholder="you@company.com" />
                        </div>
                        <div className="mb-5">
                            <label htmlFor="auth-password" className="d-block">Password</label>
                            <div className="position-relative">
                                <input id="auth-password" type={showPassword ? 'text' : 'password'} required autoComplete="current-password"
                                    value={password} onChange={(e) => setPassword(e.target.value)} className="form-control pe-12" placeholder="Your password" />
                                <button type="button" className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-1 text-muted"
                                    onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? 'Hide password' : 'Show password'}>
                                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                </button>
                            </div>
                        </div>
                        <button type="submit" disabled={isLoading} className="btn btn-primary w-100" style={{ height: 46 }}>
                            {isLoading ? <Loader size="20" text="Signing in" color="white" /> : 'Sign in'}
                        </button>
                    </form>

                    {switchLink && (
                        <div className="text-center mt-6 fs-7 text-muted">
                            {switchLink.prompt} <a href={switchLink.href} className="fw-semibold" style={{ color: 'var(--hp-brand-600)' }}>{switchLink.label}</a>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default AuthLayout;
